import { Globe, MessageCircle, Star } from 'lucide-react';
import { useTranslation } from 'react-i18next';

/** The three facts under the Picks row title (prototype `.pknote`). */
export function PicksNote({ className = '' }: { className?: string }) {
  const { t } = useTranslation('picks');
  const items = [
    { Icon: Star, text: t('picks:note.curated') },
    { Icon: Globe, text: t('picks:note.external') },
    { Icon: MessageCircle, text: t('picks:note.reviews') },
  ];
  return (
    <div
      className={`flex flex-wrap gap-x-3 gap-y-1 text-[13px] text-ink-2 desk:gap-x-[18px] desk:gap-y-1.5 ${className}`}
    >
      {items.map(({ Icon, text }) => (
        <span key={text} className="inline-flex items-center gap-1.5">
          <Icon className="h-[15px] w-[15px] flex-none text-brown" aria-hidden="true" />
          {text}
        </span>
      ))}
    </div>
  );
}
